<template>
    <div>
        <v-tabs vertical class="overflow-fix">
            <div v-if="showCompany">
                <p class="pa-1 primary rounded white--text text-center d-inline-block" style="width:100%;">{{ $t('companyLabel') }}: <span class="font-weight-bold">{{ this.company.name1 }}</span>
                </p>
            </div>
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{$t('profileLabel')}}
            </v-tab>
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{$t('listOfUsersLabel')}}
            </v-tab>
             <v-tab-item>
                <v-card flat class="pl-9">
                    <v-card-text class="pa-0">
                        <div class="d-flex mb-5 ">
                            <div class="black--text text-h5">{{$t('profileLabel')}}</div>
                        </div>
                    </v-card-text>
                    <CompanyProfile 
                    v-bind:companyId="parseInt(this.$route.params.affiliateCompanyId)"  
                    v-bind:showUserPath="'/dashboard/spa-user/'"/>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat class="pl-9">
                    <v-card-text class="pa-0">
                        <div class="d-flex  mb-5 ">
                            <div class="black--text text-h5 text-center">{{$t('listOfUsersLabel')}}</div>
                        </div>
                    </v-card-text>
                        <AffiliatePartnershipSalesTable 
                        v-bind:companyId="parseInt(this.$route.params.affiliateCompanyId)"  
                        v-bind:showUserPath="'/dashboard/afiliate-user/'"
                        />
                </v-card>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import CompanyProfile from '../../components/CompanyProfile';
import AffiliatePartnershipSalesTable from '../../components/AffiliatePartnershipSalesTable';
import UserTypes from '../../auth/userTypes';
    export default {
        components : {
            CompanyProfile,
            AffiliatePartnershipSalesTable,
        },
        data() {
            return {
                showCompany:false,
                company: '',
            }
        },
        mounted() {
            this.getCompany()
            this.canShowCompany()
        },
        methods: {
            canShowCompany() {
                if(this.$route.fullPath.includes('sale-partnerships')){
                    this.showCompany = true
                }
            },
            getCompany() {
                var companyId = this.$route.params.companyId;
                this.axios
                    .get("api/company/getbyid/", {
                        params: {
                            id: companyId,
                        },
                    })
                    .then((response) => {
                        this.company = response.data;
                    })
                    .catch((error) => {});
            },
        },
    }
</script>